import House from '../ui/House';
import { connect } from 'react-redux';
import { hostProfileSubmit, skipSubmit } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    content: state.content,
    user: state.user,
    profileElements: state.profileElements,
    localProfileElements: state.localProfileElements,
    requiredFields: state.requiredFields,
    activeProfileElements: state.activeProfileElements
  });

const mapDispatchToProps = dispatch =>
  ({
    onHostProfileSubmit(payload) {
       dispatch(
         hostProfileSubmit(payload)
       );
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(House);

export default Container;
